import React from "react";
import { Box, Stack } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import { useNavigate } from "react-router-dom";
import program_start from "static/image/onboarding/program_start.svg";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";
import useMixpanelMKT from "../../../../hooks/useMixpanelMKT";
import {
  MktVersionTypes,
  versionToPathPrefix,
} from "../../../../components/mkt/mktVersionUtils";
import { useRecoilValue } from "recoil";
import { webTestTypeAtom } from "../../../../recoil/webTestTypeAtom";

export default function Start_4_Promotion({
  version = "v4",
}: {
  version?: MktVersionTypes;
}) {
  const navigate = useNavigate();
  const webTestType = useRecoilValue(webTestTypeAtom);

  const trackPromotion = useMixpanelMKT({
    eventName: "프로그램 구성하기 버튼 클릭",
    version: version,
  });

  const handleNext = () => {
    trackPromotion();
    if (webTestType?.type === "b") {
      navigate(`/${versionToPathPrefix(version)}-onboarding/goal/1`, {
        replace: true,
      });
    } else {
      navigate(`/${versionToPathPrefix(version)}-onboarding/demographic/1`, {
        replace: true,
      });
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", height: "70vh" }}>
      <Stack
        sx={{
          height: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Stack spacing={2}>
          <CustomTypography
            variant="Subtitle"
            fontWeight={700}
            sx={{
              color: theme.vars.palette.Content.Highlight,
            }}
          >
            {webTestType?.type === "b"
              ? "잘 찾아오셨어요."
              : "과학이 만드는 변화를 지금 시작하세요."}
          </CustomTypography>
          <CustomTypography
            variant="Subtitle"
            fontWeight={500}
            sx={{
              color: theme.vars.palette.Content.Strong,
            }}
          >
            {webTestType?.type === "b"
              ? "디스턴싱은 이해하고 훈련하는 멘탈케어 프로그램입니다."
              : "디스턴싱은 현대 정신의학 이론을 집대성한 전세계 유일의 근거 기반\n" +
                "인지행동치료 프로그램입니다."}
          </CustomTypography>
        </Stack>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 0,
            marginTop: "50px",
          }}
        >
          <img
            src={program_start}
            alt={"onboarding"}
            style={{
              maxWidth: "100%",
              maxHeight: "80%",
              objectFit: "contain",
            }}
          />
        </Box>
        {webTestType?.type === "b" && (
          <CustomTypography
            variant="Caption"
            fontWeight={500}
            sx={{
              textAlign: "center",
              color: theme.vars.palette.Content.Medium,
            }}
          >
            {"디스턴싱은 현대 정신의학 이론을 집대성하여\n" +
              "행동과학 중심으로 재구성한 전세계 유일의\n" +
              "근거 기반 인지행동치료 프로그램입니다."}
          </CustomTypography>
        )}
      </Stack>
      <BottomNextButtonTmp
        disabled={false}
        onClick={handleNext}
        text={"프로그램 구성하기"}
        highlightBackground={true}
      />
    </Box>
  );
}
